import mitt from 'mitt'

import { MessageType } from './type'

export const MessageAddEvent = Symbol('MessageAddEvent')
export const MessageRemoveEvent = Symbol('MessageRemoveEvent')

export const emitter = mitt<{
  [MessageAddEvent]: MessageType
  [MessageRemoveEvent]: string
}>()
